import Header from "../../componants/header";
import Footer from "../../componants/footer";
import BannerForAll from "../../componants/bannerForAll";
import webDesignImage from '../../images/cardpageimages/technicalcourse/webdesingimage.jpg';
import IntroVideos from "../../componants/introvideos";
import WebDesignModule from "../../componants/allCourseModule/TechnicalCourseModule/WebDesignModule";

function WebDesign() {
  return (
    <>
      <Header />
      <BannerForAll
        title="WEB DESIGN FULL COURSE"
        text="Our Web Design Full Course covers essential skills in HTML, CSS, JavaScript, and design principles to create visually appealing and user-friendly websites. Ideal for beginners and aspiring web designers, this course teaches layout design, responsive web techniques, and UX/UI basics, empowering you to build professional-grade websites from scratch."
        imageone={webDesignImage}
        imagetwo={webDesignImage}
      />
      <IntroVideos
        vone="https://www.youtube.com/embed/dQw4w9WgXcQ"
        vtwo="https://www.youtube.com/embed/3JZ_D3ELwOQ"
        topic="WEB DESIGN"
      />
      <WebDesignModule />
      <Footer />
    </>
  );
}

export default WebDesign;
